import { createAsyncThunk } from "@reduxjs/toolkit";
import { convertToEmployeeApi, getOnboardings, getSingleOnboarding, saveOnboardingApi, updateJoiningStatusApi } from "../../apiservice/hrpayroll";


export const fetchOnboardings = createAsyncThunk(
  'onboarding/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getOnboardings();      
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchSingleOnboarding = createAsyncThunk(
  'singleOnboarding/fetch',
  async (id, { rejectWithValue }) => {
    try {
      const res = await getSingleOnboarding({id});       
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const saveOnboarding = createAsyncThunk(
  "onboarding/save",
  async (data, { rejectWithValue }) => {
    try {
      const res = await saveOnboardingApi(data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateOnboardingStatus = createAsyncThunk(
  "onboarding/convert",
  async (id, { rejectWithValue }) => {
    console.log(id)
    try {
      const res = await convertToEmployeeApi({id});
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const updateJoiningStatus = createAsyncThunk(
    "onboarding/updateJoiningStatus",
    async (payload,{rejectWithValue}) => {
        try{
            const res = await updateJoiningStatusApi(payload);
            return res.data;
        }catch(err){
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);